import type { ApolloError } from "@apollo/client";
import type { InsuredWithDuplicateFlagQuery, OpportunitiesQuery, PoliciesListQuery, QuotesQuery } from "@qw/graphql";
import { createContext, useContext } from "react";

type Opportunities = OpportunitiesQuery["opportunities"];
type Policies = PoliciesListQuery["policies"];
type Quotes = QuotesQuery["quotes"];

interface InsuredContextValue {
  error?: ApolloError;
  insured: NonNullable<InsuredWithDuplicateFlagQuery["insured"]>;
  insuredId: string;
  needsClassCodes: boolean;
  loading: boolean;
  opportunities: Opportunities;
  activeOpportunities: Opportunities;
  opportunitiesLoading: boolean;
  activePolicies: Policies;
  activePoliciesLoading: boolean;
  quotes: Quotes;
  draftQuotes: Quotes;
  sentQuotes: Quotes;
  quotesLoading: boolean;
  refetch: () => void;
}

export const InsuredContext = createContext<InsuredContextValue | null>(null);

export const useInsured = () => {
  const context = useContext(InsuredContext);

  if (!context) {
    throw new Error("useInsured must be used within an InsuredProvider");
  }

  return context;
};

export const useOptionalInsured = () => useContext(InsuredContext);
